import {call, put, select, takeLatest} from 'redux-saga/effects'
import {
  getAll,
  setError,
  setList,
  setSuccess,
  updateBranchStatus,
  create,
  setShowAddBranchModal,
  getBranchUsers,
  branchUsersFilterDataChange,
  setBranchUsersList,
  createBranchUser,
  setShowAddBranchUserModal,
  filterDataChange,
  updateUserBranchStatus,
} from './BranchRedux'
import {ResponseGenerator} from '../../../shared/models/ResponseGenerator'
import {
  getAllBranchesApi,
  updateBranchStatusApi,
  createBranchApi,
  getAllUsersBranchesApi,
  createBranchUserApi,
  updateBranchUserStatusApi,
} from './BranchApi'
import {HTTP_CODE} from '../../../shared/constants'
import {RootState} from '../../../../setup/redux/Store'
import {BranchListFilterModel} from '../models/BranchListFilterModel'
import {getIntl} from '../../../shared/intl'
import {getCurrentIntl} from '../../../shared/utils/i18nUtils'
function* handleGetAllBrands(action: ReturnType<typeof getAll>) {
  try {
    const filterData: BranchListFilterModel = yield select(
      (state: RootState) => state.branch.filter
    )
    const response: ResponseGenerator = yield call(getAllBranchesApi, filterData)

    if (response && response.status !== HTTP_CODE.SUCCESS) {
      throw new Error(response.data.message)
    }

    yield put(setList(response.data))
  } catch (error: any) {
    yield put(setError(error.message))
  }
}

function* handleUpdateBrandStatus(action: ReturnType<typeof updateBranchStatus>) {
  try {
    const {id, status, targetPersonInChargeId, targetBranchId} = action.payload
    const response: ResponseGenerator = yield call(
      updateBranchStatusApi,
      id,
      status,
      targetPersonInChargeId,
      targetBranchId
    )

    if (response && response.status !== HTTP_CODE.SUCCESS) {
      throw new Error(response.data.message)
    }

    // Use different success messages based on the operation type
    let successMessageKey = 'SERVER.UPDATED'
    if (status === 'ACTIVE' && targetPersonInChargeId) {
      successMessageKey = 'BRANCH.ACTIVATE.SUCCESS'
    } else if (status === 'INACTIVE' && targetBranchId) {
      successMessageKey = 'BRANCH.DEACTIVATE.SUCCESS'
    }
    const intl = getIntl()
    yield put(setSuccess(intl.formatMessage({id: successMessageKey})))
    yield put(getAll())
  } catch (error: any) {
    yield put(setError(error.message))
  }
}

function* handleCreateBrand(action: ReturnType<typeof create>) {
  try {
    const response: ResponseGenerator = yield call(createBranchApi, action.payload)

    if (response && response.status !== HTTP_CODE.CREATE_NEW) {
      throw new Error(response.data.message)
    }
    yield put(setShowAddBranchModal(false))

    const currentIntl = getCurrentIntl()
    yield put(setSuccess(currentIntl.formatMessage({id: 'SERVER.CREATED'})))
    yield put(getAll())
  } catch (error: any) {
    yield put(setError(error.message))
  }
}
function* handleGetBrandUsers(action: ReturnType<typeof getBranchUsers>) {
  try {
    const filterData: BranchListFilterModel = yield select(
      (state: RootState) => state.branch.listBranchUsersFilter
    )
    const response: ResponseGenerator = yield call(getAllUsersBranchesApi, filterData)
    if (response && response.status !== HTTP_CODE.SUCCESS) {
      throw new Error(response.data.message)
    }
    yield put(setBranchUsersList(response.data))
  } catch (error: any) {
    yield put(setError(error.message))
  }
}
function* handleCreateBrandUser(action: ReturnType<typeof createBranchUser>) {
  try {
    const response: ResponseGenerator = yield call(createBranchUserApi, action.payload)

    if (response && response.status !== HTTP_CODE.CREATE_NEW) {
      throw new Error(response.data.message)
    }
    yield put(setShowAddBranchUserModal(false))

    const currentIntl = getCurrentIntl()
    yield put(setSuccess(currentIntl.formatMessage({id: 'SERVER.CREATED'})))
    yield put(getBranchUsers())
  } catch (error: any) {
    yield put(setError(error.message))
  }
}
function* handleUpdateUserBranchStatus(action: ReturnType<typeof updateUserBranchStatus>) {
  try {
    const {userIds, status} = action.payload
    const response: ResponseGenerator = yield call(updateBranchUserStatusApi, userIds, status)

    if (response && response.status !== HTTP_CODE.SUCCESS) {
      throw new Error(response.data.message)
    }

    const currentIntl = getCurrentIntl()
    yield put(setSuccess(currentIntl.formatMessage({id: 'SERVER.UPDATED'})))
    yield put(getBranchUsers())
  } catch (error: any) {
    yield put(setError(error.message))
  }
}
export default function* saga() {
  yield takeLatest([getAll.type, filterDataChange.type], handleGetAllBrands)
  yield takeLatest(updateBranchStatus.type, handleUpdateBrandStatus)
  yield takeLatest(create.type, handleCreateBrand)
  yield takeLatest([getBranchUsers.type, branchUsersFilterDataChange.type], handleGetBrandUsers)
  yield takeLatest(createBranchUser.type, handleCreateBrandUser)
  yield takeLatest(updateUserBranchStatus.type, handleUpdateUserBranchStatus)
}
